import { graphql, useStaticQuery } from "gatsby"

type ContentfulImage = {
  assets: {
    edges: {
      node: {
        node_locale: string
        contentful_id: string
        file: {
          url: string
          contentType: string
          fileName: string
        }
        description: string
        gatsbyImageData: any
      }
    }[]
  }
}
export const useContentfulImage = (assetUrl: string) => {
  const { assets }: ContentfulImage = useStaticQuery(
    graphql`
    query CONTENTFUL_IMAGE_QUERY ($locale: String) {
      assets: allContentfulAsset(filter: {node_locale: {eq: $locale}}) {
        edges {
          node {
            node_locale
            contentful_id
            file {
              url
              contentType
              fileName
            }
            description
            gatsbyImageData
          }
        }
      }
    }
    `
  )

 
  

  const asset = assets.edges.find(
    ({ node }) =>
      node.contentful_id === assetUrl && node.node_locale === process.env.language
  )
  return asset
}
